import { Observable } from "zen-observable-ts";
import { Auth } from "../auth";

export type Claims = { [key: string]: any };

export const refreshTokenObservable = new Observable<Claims>(observer => {
  Auth.ensureAuthenticated(true)
    .then(claims => {
      observer.next(claims!);
      observer.complete();
    })
    .catch(error => observer.error(error));
});
